import React, { useState } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const SignUp = () => {
  const [login, setLogin] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  
  const navigate = useNavigate();
    const handleRecaptchaChange = (value) => {
      setRecaptchaValue(value);
    };
  
  const handleChange = (e) => {
    if (e.target.name === 'login') {
      setLogin(e.target.value);
    } else if (e.target.name === 'email') {
      setEmail(e.target.value);
    } else if (e.target.name === 'password') {
      setPassword(e.target.value);
    } 
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // if (!recaptchaValue) {
    //   console.error('Veuillez compléter reCAPTCHA.');
    //   return;
    // }

    const userForm = {
      login: login,
      email: email,
      password: password,
      recaptchaValue: recaptchaValue, 
    };

    axios.post(`${process.env.REACT_APP_API}/inscription`, userForm)
      .then((res) => {
        console.log(res.data);
        navigate('/connexion');
      })
      .catch((error) => {
        console.log('Erreur lors de l\'inscription');
        toast.error(error.response?.data?.message || "Erreur lors de l'inscription");
      });
  };


  return (
    <main>
      <section className='form-container'>
        <form onSubmit={handleSubmit} encType='multipart/form-data'>
          <h3>Enregistrez-vous maintenant</h3>

          <label htmlFor="login">
            <p>Votre nom <strong>*</strong></p>
            <input
              className='box'
              id="login"
              type='text'
              placeholder='Entrez votre nom'
              name="login"
              onChange={handleChange}
              required
            />
          </label>

          <label htmlFor="email">
            <p>Votre e-mail <strong>*</strong></p>
            <input
              id="email"
              type='email'
              name='email'
              placeholder='Entrez votre e-mail'
              required
              maxLength='50'
              className='box'
              onChange={handleChange}
            />
          </label>

          <label htmlFor="password">
            <p>Votre mot de passe <strong>*</strong></p>
            <input
              id="password"
              type='password'
              name='password'
              placeholder='Entrez votre mot de passe'
              required
              minLength='8'
              maxLength='20'
              className='box'
              onChange={handleChange}
            />
          </label>

{/* 

  <ReCAPTCHA
            sitekey="6LdSviIpAAAAANGQWccecL4WUhhQ6kwI4N_7f6Hl"
            onChange={handleRecaptchaChange}
          />  */}


          <button type='submit' name='submit' className='btn' /*disabled={!recaptchaValue}*/ >
            S'inscrire
          </button>
        </form>
      </section>
    </main>
  );
};

export default SignUp;